import angular from "angular";
import IntegrationCardSmartvault from "./integration-card-smartvault/integration-card-smartvault";

const IntegrationModule = angular
  .module("modules.integration", [])
  .component("integrationCardSmartvault", IntegrationCardSmartvault);

export default IntegrationModule;
